<template>
  <v-dialog
    v-model="dialog"
    v-shortkey.once="['esc']"
    :max-width="maxWidth"
    :fullscreen="$vuetify.breakpoint.xs"
    @shortkey="escape"
  >
    <v-overlay
      :value="loading"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <template v-slot:activator="{ on: btn_dialog, attrs }">
      <tooltip-btn
        v-if="activatorIcon"
        :color="color"
        :icon="icon"
        :tooltip="title"
        v-bind="attrs"
        v-on="{ ...btn_dialog }"
        @click="openDialog()"
      />
      <v-btn
        v-else-if="activatorButton"
        :color="color"
        :class="customClass"
        v-bind="attrs"
        v-on="{ ...btn_dialog }"
        @click="openDialog()"
      >
        {{ $t(title) }}
        <v-icon
          right
          dark
        >
          {{ icon }}
        </v-icon>
      </v-btn>
      <v-btn
        v-else-if="activatorLink"
        text
        :color="color"
        :class="customClass"
        v-bind="attrs"
        v-on="{ ...btn_dialog }"
        @click="openDialog()"
      >
        {{ $t(title) }}
      </v-btn>
      <a
        v-else-if="activatorSimpleLink"
        v-bind="attrs"
        v-on="{ ...btn_dialog }"
        @click="openDialog()"
      >
        {{ $t(title) }}
      </a>
    </template>

    <v-card>
      <v-card-title
        v-if="!avatar"
        class="blue lighten-3"
      >
        <span class="text-h5 font-weight-regular">{{ title }}</span>
      </v-card-title>

      <v-divider
        v-if="!avatar"
      />

      <v-card-actions v-if="headerOn">
        <v-spacer />
        <v-btn
          v-shortkey.once="['esc']"
          color="cancel"
          @click="escape"
          @shortkey="escape"
        >
          {{ $t('back') }}
        </v-btn>
      </v-card-actions>

      <v-card-text v-if="false" class="mt-4">
        <v-container class="py-0">
          <!-- info -->
        </v-container>
      </v-card-text>

      <slot name="info" />

      <v-divider />

      <v-card-actions>
        <slot name="button" />

        <v-spacer />
        <v-btn
          v-shortkey.once="['esc']"
          color="cancel"
          @click="escape"
          @shortkey="escape"
        >
          {{ $t('back') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'CumulusInfoDialog',
    model: {
      prop: 'open',
      event: 'valuechange',
    },
    props: {
      icon: {
        type: String,
        default: '$edit',
      },
      avatar: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: 'datas',
      },
      color: {
        type: String,
        default: 'white',
      },
      open: {
        type: Boolean,
        default: false,
      },
      activatorIcon: {
        type: Boolean,
        default: false,
      },
      activatorButton: {
        type: Boolean,
        default: false,
      },
      activatorLink: {
        type: Boolean,
        default: false,
      },
      activatorSimpleLink: {
        type: Boolean,
        default: false,
      },
      maxWidth: {
        type: Number,
        default: 500,
      },
      headerOn: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      customClass: {
        type: String,
        default: 'mb-2 ml-2',
      },
    },
    data () {
      return {
        message: '',
        // formTitle: 'Statisztika / Információ',
      }
    },
    computed: {
      dialog: {
        get: function () {
          return this.open
        },
        set: function (value) {
          this.$emit('valuechange', value)
        },
      },
      page_title () { return this.$t(this.newItem ? 'insert' : 'edit', { type: this.$t(this.title) }) },
    },
    watch: {
      dialog (val) {
        val || this.closeDialog()
      },
      open (val) {
        console.log('change open : ' + this.dialog)
      },
    },
    methods: {
      escape () {
        // this.closeDialog()
        this.$emit('escape')
      },
      openDialog () {
        console.log('open')
        this.$emit('open')
      },
      closeDialog () {
        this.dialog = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto

// max-height: calc(100vh - 500px)
</style>
